<template>
  <div>
    <div style="width: 100%; position: fixed; z-index: 1000; overflow: hidden">
      <van-search v-model="searchValue" show-action background="#324282" clearable left-icon="#" placeholder="请输入搜索关键词" @search="onSearch" @cancel="onCancel">
        <template #action>
          <div style="padding-top: 10px">
            <van-icon name="search" size="20" color="#fff" />
            <van-icon style="margin-left: 10px" size="20" name="filter-o" color="#fff" @click="search.visible = true" />
          </div>
        </template>
      </van-search>
    </div>

    <add-btn @add="update(type)"></add-btn>
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
      <van-cell v-for="(item,index) in list" :key="index">
        <div class="flex-between" v-if="item">
          <div>
            <div class="custName-wrap">
              <div style="
                  max-width: 70%;
                  font-size: 14px;
                  color: black;
                  margin-right: 5px;
                ">
                {{ item.custName }}
              </div>
              <div>{{ item.createTime | timeFormat }}</div>
            </div>
            <div>
              <van-tag color="#ccc" style="margin-right: 10px" plain type="primary" v-if="item.fuSalesName">{{ item.fuSalesName }}</van-tag>
              <van-tag color="#ccc" style="margin-right: 10px" plain type="primary" v-if="item.custLevelId">{{ item.custLevelId }}</van-tag>
              <van-tag color="#ccc" plain type="primary" v-if="item.industryName">{{ item.industryName }}</van-tag>
            </div>
          </div>

          <van-icon name="arrow" class="arrow-more" size="30" @click="toCustomerHighseas(item)" />
        </div>
      </van-cell>
    </van-list>

    <van-dialog v-model="show" title="添加客户" @confirm="confirm" close-on-click-overlay>
      <div style="height: 300px; overflow: scroll; margin: 10px 10px">
        <van-cell-group>
          <van-field v-model="form.custName" label="客户名称" />
          <van-field readonly clickable v-model="form.custLevelName" @click="showPicker('custLevelId')" label="客户等级" />
          <van-field label="状态">
            <template #input>
              <van-radio-group v-model="form.status" direction="horizontal">
                <van-radio :name="item.dictValue" v-for="item in statusOptions" :key="item.dictValue">{{ item.dictLabel }}</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field readonly clickable v-model="form.areaName" label="地区" @click="showPicker('areaId')" />
          <van-field readonly clickable v-model="form.industryCodeName" label="行业" @click="showPicker('industryCode')" />
          <van-field readonly clickable v-model="form.custTypeName" @click="showPicker('custType')" label="客户类型" />
          <van-field readonly clickable v-model="form.custSourceName" @click="showPicker('custSource')" label="客户来源" />
          <van-field v-model="form.scale" label="企业规模" />
          <van-field v-model="form.mainProducts" label="主营产品" />
          <van-field v-model="form.distributionUserName" label="分配用户" />
          <van-field v-model="form.teamPeople" label="协作人" />
          <van-field v-model="form.website" label="企业网站" />
          <van-field v-model="form.custAddress" label="地址" />
          <van-field v-model="form.orderNum" type="number" label="排序" />
          <van-field v-model="form.custProfile" label="客户简介" />
          <van-field v-model="form.remark" label="备注" />
        </van-cell-group>
      </div>
    </van-dialog>

    <van-popup v-model="picker.visible" position="bottom">
      <van-area v-if="picker.formKey === 'areaId'" :area-list="picker.areaList" :columns-num="2" @confirm="areaConfirm" @cancel="pickerCancel" />
      <van-picker v-else :title="picker.title" show-toolbar :columns="picker.columns" @confirm="pickerConfirm" @cancel="pickerCancel" @change="pickerChange" />
    </van-popup>
    <search-pop :show="true" />
    <!-- <van-popup v-model="search.visible" position="right" style="height: 100%; width: 80%">
      <div class="type-list">
        <div class="title">类型</div>
        <div class="list-wrapper">
          <van-button plain hairline size="mini" v-for="item in myCust" @click="item.active = !item.active" :color="item.active ? 'rgb(7, 193, 96)' : ''" :key="item.value">{{ item.value }}</van-button>
        </div>
      </div>
      <div style="position: fixed; bottom: 0; padding: 20px; width: 80%">
        <van-button type="primary" style="margin-right: 5px" @click="search.visible = false">重置</van-button>
        <van-button type="info" @click="search.visible = false">确认</van-button>
      </div>
    </van-popup> -->
  </div>
</template>

<script>
import moment from "moment";
import SearchPop from "../fina/components/ReceSearchPop"
import {
  Search,
  List,
  Cell,
  Button,
  Tag,
  Dialog,
  Area,
  Toast,
  Icon,
  Field,
  Col,
  Row,
  CellGroup,
  Popup,
  Picker,
  Radio,
  RadioGroup,
} from "vant";
import {
  listCust,
  getCust,
  delCust,
  addCust,
  updateCust,
  applyCust,
  exportCust,
  importTemplate,
} from "@/api/scrm/custhighseas";
import { getDicts } from "@/api/system/dict/data";
// import { selectAllCustLevel } from "@/api/scrm/custlevel";
import { getProvinceCityList } from "@/api/system/area";
import { getTwoLevelIndustryList } from "@/api/system/qqAdIndustry";
import { areaList } from "@vant/area-data";
import AddBtn from "@/components/common/AddBtn";
export default {
  name: "KehuIndex",
  components: {
    [Search.name]: Search,
    [List.name]: List,
    [Cell.name]: Cell,
    [Field.name]: Field,
    [Col.name]: Col,
    [Row.name]: Row,
    [Button.name]: Button,
    [CellGroup.name]: CellGroup,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [Area.name]: Area,
    [Icon.name]: Icon,
    [Tag.name]: Tag,
    [Toast.name]: Toast,
    [Dialog.Component.name]: Dialog.Component,
    AddBtn,
    SearchPop
  },
  filters: {
    timeFormat(val) {
      return moment(val).format("YYYY-MM-DD");
    },
  },
  data() {
    return {
      myCust: [
        {
          value: "我的客户",
          active: false,
        },
        {
          value: "负责的",
          active: false,
        },
        {
          value: "创建的",
          active: false,
        },
        {
          value: "参与的",
          active: false,
        },
        {
          value: "我关注的客户",
          active: false,
        },
        {
          value: "共享给我的客户",
          active: false,
        },
      ],
      picker: {
        visible: false,
        title: "",
        columns: [],
        formKey: "",
        areaList,
      },
      search: {
        visible: false,
      },
      searchValue: "",
      loading: false,
      finished: false,
      list: [],
      type: "add",
      show: false,
      custList: [],
      // 客户等级
      custLevelOptions: [],
      // 地区树选项
      areaOptions: [],
      // 行业树选项
      industryOptions: [],
      // 状态数据字典
      statusOptions: this.$store.state.dictOptions.status || [],
      // 客户类型字典
      custTypeOptions: this.$store.state.dictOptions.crmCustType || [],
      // 释放类型
      releaseModeOptions: [],
      // 客户来源字典
      custSourceOptions: this.$store.state.dictOptions.custSource || [],
      form: {
        custName: "",
        custLevelId: "",
        custLevelName: "",
        status: 0,
        remark: "",
        custProfile: "",
        orderNum: "",
        custAddress: "",
        website: "",
        teamPeople: "",
        distributionUserName: "",
        mainProducts: "",
        scale: "",
        custSource: "",
        custSourceName: "",
        custType: "",
        custTypeName: "",
        industryCodeName: "",
        industryCode: "",
        areaId: "",
        areaName: "",
      },
      queryParams: {
        pageNum: 0,
        pageSize: 10,
        custLevelId: null,
        custName: null,
        custSource: null,
        custType: null,
        clueLabel: null,
        industryCode: null,
        industryName: null,
        businessTypeId: null,
        businessTypeName: null,
        areaId: null,
        areaName: null,
        custStatus: 0, //自建客户都是属于公海客户
        scale: null,
        mainProducts: null,
        teamPeople: null,
        website: null,
        custAddress: null,
        custLogo: null,
        custProfile: null,
        openId: null,
        distance: null,
        longitude: null,
        latitude: null,
        distributionUserid: null,
        distributionUserName: null,
        distributionTime: null,
        lastFollowTime: null,
        lastFollowContent: null,
      //  turnOpportunityTime: null,
        myUserid: null,
      //  followUserid: null,
     //   followUserName: null,
        status: null,
        orderNum: null,
      },
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      this.getCustLevelList();
      //释放类型
      getDicts("release_mode").then((response) => {
        this.releaseModeOptions = response.data;
      });
      //客户来源
      // getDicts("crm_cust_source").then((response) => {
      //   this.custSourceOptions = response.data;
      // });
      // 获取地区（省、市）
      getProvinceCityList().then((response) => {
        this.areaOptions = this.handleTree(response.data, "areaId");
      });
      // 获取行业（前2级）
      getTwoLevelIndustryList().then((response) => {
        this.industryOptions = this.handleTree(response.data, "industryCode");
      });
      await this.handleList();
    },
    onSearch(val) {
      Toast(val);
    },
    onCancel() {
      Toast("查询");
    },
    toCustomerHighseas(item) {
      this.$router.push(`/customer/${item.custId}`);
    },
    showPicker(type) {
      this.picker.formKey = type;
      if (type === "custLevelId") {
        this.picker.columns = this.custLevelOptions.map((ele) => ele.levelName);
      }
      if (type === "custSource") {
        this.picker.columns = this.custSourceOptions.map(
          (ele) => ele.dictLabel
        );
      }
      if (type === "custType") {
        this.picker.columns = this.custTypeOptions.map((ele) => ele.dictLabel);
      }
      if (type === "industryCode") {
        this.picker.columns = this.industryOptions.map(
          (ele) => ele.industryName
        );
      }
      this.picker.visible = true;
    },
    pickerConfirm(value, index) {
      if (this.picker.formKey === "custLevelId") {
        this.form.custLevelId = this.custLevelOptions[index].custLevelId;
        this.form.custLevelName = this.custLevelOptions[index].levelName;
      }
      if (this.picker.formKey === "custSource") {
        this.form.custSource = this.custSourceOptions[index].dictValue;
        this.form.custSourceName = this.custSourceOptions[index].dictLabel;
      }
      if (this.picker.formKey === "custType") {
        this.form.custType = this.custTypeOptions[index].dictValue;
        this.form.custTypeName = this.custTypeOptions[index].dictLabel;
      }
      if (this.picker.formKey === "industryCode") {
        this.form.industryCode = this.industryOptions[index].industryCode;
        this.form.industryCodeName = this.industryOptions[index].industryName;
      }
      this.picker.visible = false;
    },
    areaConfirm(values) {
      this.form.areaId = values[values.length - 1].code;
      this.form.areaName = values[values.length - 1].name;
      this.picker.visible = false;
    },
    pickerCancel() { },
    pickerChange() { },
    update(type, row) {
      this.type = type;
      this.show = true;
      if (row) {
      }
    },
    confirm() {
      if (this.type !== "add") {
        updateCust(this.form).then((response) => {
          this.msgSuccess("修改成功");
          this.open = false;
          this.getList();
        });
      } else {
        addCust(this.form).then((response) => {
          Toast("新增成功");
          this.dialogVisible = false;
          this.handleList();
        });
      }
    },
    async handleList() {
      this.loading = true;
      const res = await listCust(this.queryParams);
      if (res.code === 200) {
        this.list = this.list.concat(res.rows);
        this.queryParams.pageNum += 1;
        this.loading = false;
        this.finished = this.list.length >= res.total;
      }
    },
    onLoad() {
      this.handleList();
    },
    //获取用户等级
    // getCustLevelList() {
    //   selectAllCustLevel(null).then((response) => {
    //     this.custLevelOptions = response.data;
    //   });
    // },
  },
};
</script>

<style scoped lang='less'>
@import url("@/style/index.less");
.type-list {
  padding: 10px;
  .title {
    font-size: 40px;
    margin-bottom: 20px;
  }
  .list-wrapper {
    display: flex;
    flex-wrap: wrap;
    button {
      margin: 10px;
    }
  }
}
.arrow-more {
  color: #ccc;
}
</style>
